import type { ReactNode } from 'react';

export const symbol_play_pause: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M247-363q-15 10-31 1.44-16-8.57-16-26.44v-184q0-17.87 16-26.44 16-8.56 31 1.44l136 92q14 9.11 14 25.06Q397-464 383-455l-136 92Zm301.5 34.37Q540-337.25 540-350v-260q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v260q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm160 0Q700-337.25 700-350v-260q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v260q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
